import React from "react";

const HeaderLogin = () => {
  return (
    <div className="header-login ms-1 text-end mb-5">
      <div className="mb-3">
       <img src="/images/game/logo.png" />
      </div>
        
    </div>
  );
};
export default HeaderLogin;
